import React, { Component } from "react";

import "./Footer.less";

export default class  Footer extends Component {
  state = {
    height: 49,
  };

  __divRef = null;
  __refreshTimeId = null;
  __resizeObserver = null;

  componentWillUnmount() {
    if (this.__resizeObserver) {
      this.__resizeObserver.disconnect();
      this.__resizeObserver = null;
    }
  }

  onDivRef = (e) => {
    if (e) {
      this.__divRef = e;
      this.refreshHeight(333);
      this.__initResizeObserver();
    };
  }

  refreshHeight = (ms = 0) => {
    if (this.__refreshTimeId) {
      clearTimeout(this.__refreshTimeId);
      this.__refreshTimeId = null;
    }
    if (0 === ms) {
      this.refreshHeightHandle();
    } else {
      this.__refreshTimeId = setTimeout(this.refreshHeightHandle, ms);
    }
  };

  refreshHeightHandle = () => {
    const boxEle = this.__divRef.querySelector(".nano-panel-footer-box");
    const height = boxEle.offsetHeight;
    if (height !== this.state.height) {
      this.setState({
        ...this.state,
        height,
      });
    }
    // 调整父面板底部，留出自身高度
    // this.__divRef.parentElement.style["paddingBottom"] = height + "px";
  };

  __initResizeObserver = () => {
    this.__resizeObserver = new ResizeObserver(() => {
      this.refreshHeight(333);
    });
    this.__resizeObserver.observe(this.__divRef);
  };

  render() {
    return (
      <div
        className="nano-panel-footer"
        ref={this.onDivRef}
        style={{
          height: this.state.height,
        }}
      >
        <div className="nano-panel-footer-box">
          {this.props.children}
        </div>
      </div>
    );
  };
}
